import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { COLOR_GREY_2 } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledStatus = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isHovered",
})<{ isHovered?: boolean }>(({ isHovered }) => ({
  opacity: isHovered ? 1 : 0,
  cursor: "pointer",
  marginLeft: "1rem",
  display: "flex",
}));

export const StyledGrid = styled(Grid, {
  shouldForwardProp: (propName) => !["isHidden"].includes(propName),
})<{
  isHidden?: boolean;
}>`
  opacity: ${({ isHidden }) => (isHidden ? 0.4 : 1)};
  display: flex;

  :hover {
    background-color: ${COLOR_GREY_2};
  }
`;

export const StyledHeaderContainer = styled(Box)`
  ${flex({ ai: "center" })};
  padding: 0.75rem;
`;

export const StyledText = styled(Box)`
  ${flex({ ai: "center" })};
`;
